import { render } from "./QuotationOfWantToBuy.vue?vue&type=template&id=edd60d30&scoped=true&ts=true&lang=pug"
import script from "./QuotationOfWantToBuy.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuotationOfWantToBuy.vue?vue&type=script&setup=true&lang=ts"

import "./QuotationOfWantToBuy.vue?vue&type=style&index=0&id=edd60d30&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edd60d30"]])

export default __exports__